import $http from "../../axios";
import { Notification } from 'element-ui';
import moment from "moment";
export async function fetchReportData({commit, state}) {
    commit('setLoading', true);
    await $http.get('/api/report-documents-pending-order-dispatch', {params:state.params})
    .then((response) => {
        commit('setReportData', response.data.data);
    })
    .catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 1500,
            customClass: 'notification-box',
        });
    }).finally( () => {
        commit('setLoading', false);
        }
    );
}

export async function fetchProductsReportData({commit, state}, document_id) {
    await $http.get('/api/get-products-documents-pending-order-dispatch/' + document_id)
        .then((response) => {
            console.log(response.data.data);
            commit('setDocumentProductReportData', response.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        });
}

export async function downloadDocument({
                                           state
                                       }, documentToPdf) {
    console.log(documentToPdf);
    let name = documentToPdf.code_voucher_type + ' No. ' + documentToPdf.consecutive + '.pdf'
    await $http({
        url:  '/api/documentos/descargar-pdf/' + documentToPdf.id,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });
    })
}

export async function sendDocumentWmsDispatch({
                                           state
                                       }, documentSend) {
    return await $http.post('/api/send-document-wms-dispatch/' + documentSend.id)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        });
}


// WEBPACK FOOTER //
// ./src/modules/report-document-pending-dispatch-order/actions.js